const dev = {
    tokenUrl: "http://localhost:50326/api/auth"
};

const usertest = {
    tokenUrl: "https://amtrustchatbot-dev.azurewebsites.net/api/auth"
};

const prod = {
    tokenUrl: "https://amtrustchatbot-prod.azurewebsites.net/api/auth"
};

const config = process.env.REACT_APP_STAGE === 'production'
    ? prod
    : (process.env.REACT_APP_STAGE === 'usertest'
        ? usertest
        : dev);

export default config;
